import blankButtonStyle from "../../style/BlankButtonStyle";

const Discord = (props) => {
    const redirectToDiscord = function () {
        window.location.href = "https://discord.gg/DV26QNW9ew"
    }

    return <div>
        <button onClick={redirectToDiscord} style={{
            ...blankButtonStyle,
            display: "flex",
            alignItems: "center",
            padding: "1em",

        }}>
            <img src={`${process.env.PUBLIC_URL}/assets/discord_logo_128.png`} className="icon" style={{
                width: "4em",
                height: "4em",
            }} />
            <span style={{
                color: "white",
                fontWeight: "bold",
                padding: ".5em"
            }}>Join the community on Discord</span>
        </button>
    </div>

}

export default Discord;